import React, { useEffect, useState } from 'react'
import { Link } from 'react-router'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { useSelector } from 'react-redux'
import { LuLogOut } from 'react-icons/lu'
import authService from '../services/auth.service'

function Home() {
 
  const user = useSelector(state=>state.auth.user)
  const data = useSelector(state=>state.auth.data)
  const [timeLeft, setTimeLeft] = useState({
      days:0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    console.log("data",user)
    
    function calculateTimeLeft() {
      const now= new Date();
      const isTime= new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
      if(data.exam){ 
      const examTime = new Date(data.exam.exam_date);
      const diffInSeconds = Math.floor((examTime - isTime) / 1000);
       
  
      if (diffInSeconds <= 0) {
        return { hours: 0, minutes: 0, seconds: 0 };
      }
  
      return {
        days: Math.floor(diffInSeconds / (3600 * 24)),
        hours: Math.floor((diffInSeconds % (3600 * 24)) / 3600),
        minutes: Math.floor((diffInSeconds % 3600) / 60),
        seconds: diffInSeconds % 60,
      };
    }else{
      return {
        days:0,
        hours:0,
        minutes:0,
        seconds:0
      }
    }
    }
  
    useEffect(() => {

      const timeout = setTimeout(() => {
        setTimeLeft(calculateTimeLeft());

        const timer = setInterval(() => {
          setTimeLeft(calculateTimeLeft());
        }, 1000);
  
        return () => clearInterval(timer); 
      }, 1000);
  
      return () => clearTimeout(timeout); 
    }, [data]);
  return (
    <>
    {1>0? (<div >
      
        
        
       
    </div>):<></>}
    <Header/>
    <div className='login-container'> 
      
    <div className='card'>
      <div style={{display:"flex", justifyContent:"space-between"}}>

        <p>Welcome ! {user.name.split(",").map((u)=><span style={{display:'block',textAlign:'left',fontSize:'15px'}}>{u}</span>)}</p>
  <button onClick={()=>authService.logout()} className='toggle-button' style={{padding:'10px',display:"flex",alignItems:"center",gap:"5px"}}>
       Logout <LuLogOut/> </button>
       
      </div>
        <div className='exam-name-header' style={{marginBlock:'20px'}}>
            <ul style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between',}}>
               <li>
                <img style={{height:"80px"}} src={user.profile_image}/>
              </li>
              <li style={{padding:'20px'}} >
                <ul style={{display:'flex',flexDirection:'column',justifyContent:'start',alignItems:'start'}}>
                  {/* <li style={{fontSize:'20px',textAlign:'left'}}>
                    Welcome,
                    <br/>
                    {user.name.split(",").map((u)=><span style={{display:'block',textAlign:'left',fontSize:'15px'}}>{u}</span>)}
                  </li> */}
                  <li style={{fontSize:'19px'}}>User ID : {user.email.replace("@gmail.com","")}</li>
                  <li style={{fontSize:'19px'}}>
                    Exam  : {data.exam.exam_name} 
                      
                    
                  </li>

                   <li style={{fontSize:'19px'}}>
                    Branch : {user.department_name
} 
                      
                    
                  </li>
                   
                </ul>
              </li>
             
            </ul>
             
        </div>
        {/* {!data.exam_status.includes("Comple") && <div style={{textAlign:'center'}}>
        <span className='btn btn-success toggle-button' style={{textAlign:'center',margin:'auto'}}>
          
          <Link to="/home/instructions" style={{textDecoration:'none',color:'inherit'}}>Start Exam</Link>
          </span>
        </div> } */}

       <div style={{textAlign:'center'}}>
        <span className='btn btn-success toggle-button' style={{textAlign:'center',margin:'auto'}}>
          
          <Link to="/home/instructions" style={{textDecoration:'none',color:'inherit'}}>Start Exam</Link>
          </span>
        </div> 
        
         
         
        
         
    </div>
    </div>
    {/* <Footer/> */}
    </>
  )
}

export default Home